import { render, staticRenderFns } from "./TabIncluded.vue?vue&type=template&id=312725b0&"
import script from "./TabIncluded.vue?vue&type=script&lang=js&"
export * from "./TabIncluded.vue?vue&type=script&lang=js&"
import style0 from "./TabIncluded.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports